<form [formGroup]="_mFormGroup">
  <div class="row mt-3">
    <div class="col-sm-2">
      <label>Location<sup class="mandatory">*</sup></label>
      <select class="form-select" placeholder="Select Location" formControlName="location"
        (ngModelChange)="getSitesByCityId($event)">
        <option disabled value="">Choose City</option>
        <option *ngFor="let city of cities" [value]="city.locationId">
          {{ city.locationName }}
        </option>
      </select>
      <div class="error-msg"
        *ngIf="_mFormGroup.get('location').hasError('required') && _mFormGroup.get('location').touched">
        Please select location
      </div>
    </div>
    <div class="col-sm-2">
      <label>Site<sup class="mandatory">*</sup></label>
      <select class="form-select" formControlName="site" (change)="getMasterZone($event)">
        <option disabled value="">Choose Site</option>
        <option *ngFor="let site of _mSitesData" [value]="site.siteId">
          {{ site.siteName }}
        </option>
      </select>
    </div>
    <div class="col-sm-2">
      <label>Master Zone<sup class="mandatory">*</sup></label>
      <select class="form-select" placeholder="Master Zones" formControlName="masterZone"
        (change)="getZones($event)">
        <option disabled value="">Choose MasterZone</option>
        <option *ngFor="let masterZone of _mMasterZoneData" [value]="masterZone.id">
          {{masterZone.name}}
        </option>
      </select>
    </div>
    <div class="col-sm-2">
      <label>Zone<sup class="mandatory">*</sup></label>
      <mat-form-field class="routemap-zone" appearance="outline">
        <input type="text" placeholder="Zones" aria-label="Number" matInput formControlName="mZone"
          [matAutocomplete]="auto" (input)="zoneSearch($event)">
        <img matSuffix src="assets/images/search.svg" height="27" style="margin-top: -22px;padding-right: 5px;">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          <mat-option class="routeMapOption" *ngFor="let zone of _mZoneData" [value]="zone">
            {{zone.name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="col-sm-4" style="display: flex; justify-content: flex-end; align-items: center;">
      <button class="btn routemap-btn-solid"
        [disabled]="!(mLocation.value && mZone.value && mMasterZone.value && mSite.value)" (click)="showMapping()">Show
        Mapping</button>
    </div>
  </div>
</form>

<div fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="none stretch">
  <div class="tdw-padding-h-20"></div>
</div>

<div class="hr-line"></div>
<div class="tdw-padding-v-4"></div>
<div *ngIf="showFlag" fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="none
      stretch">
  <div class="container-routemap">
    <div class="container-routemap-top" *ngIf="rows.length>0">
      <mat-checkbox class="routeCheckBox" [checked]="isAllChecked()" (change)="checkAll($event)"
        style="position: relative; right: 10px;"></mat-checkbox><span
        style="font-size: 14px; font-weight: 500; font-family: 'poppins' !important; position: relative; right: 5px;">Select
        All</span>
    </div>
    <span style="font-size: 13px; font-weight: 400; font-family: 'poppins' !important;" *ngFor="let row of rows">
      <mat-checkbox class="routeCheckBox" [(ngModel)]="row.state" (change)="onValueChecked($event,row)"></mat-checkbox>
      {{row.value}}
    </span>
  </div>

  <div class="container-routemap">
    <div class="container-routemap-top" *ngIf="unPushedValues.length>0">
      <mat-checkbox class="routeCheckBox" [checked]="!isAllChecked() || isAllChecked()"
        style="position: relative; right: 10px;" (change)="unCheckAll($event)"></mat-checkbox><span
        style="font-size: 14px; font-weight: 500; font-family: 'poppins' !important; position: relative; right: 5px;">
        UnSelect
        All</span>
    </div>
    <span style="font-size: 13px; font-weight: 400; font-family: 'poppins' !important;"
      *ngFor="let row of unPushedValues">
      <mat-checkbox class="routeCheckBox" [(ngModel)]="row.state"
        (change)="onSelValueChecked($event,row)"></mat-checkbox>
      {{row.value}}
    </span>
  </div>
</div>

  <div class="row mt-3" *ngIf="getVehicleData.length > 0">
    <div class="col-sm-12 col-md-12 d-flex justify-content-end">
      <button class="btn routemap-secondbtn-solid" (click)="saveMapping()">Save
        Mapping
      </button>
    </div>
  </div>